import React, {Component, Fragment} from 'react';

class RadioGroup extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <div>
            {this.props.options.map(option => {
                return (
                    <div className="radio" key={option.value}>
                        <label>
                            <input
                                type="radio"
                                {...this.props.input}
                                value={option.value}
                                checked={this.props.input.value === option.value}
                                disabled={this.props.disabled !== undefined ? this.props.disabled : false }
                            /> {option.title}
                        </label>
                    </div>
                );
            })}
        </div>;
    }
}

export default RadioGroup;



// WEBPACK FOOTER //
// ./web/src/components/common/form/RadioGroup.jsx